var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMirColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 29,
    viewBox: "0 0 51 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Mir__color_svg__clip0_23_1391)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.894 8h-8.101c.435 2.772 3.049 5.365 5.923 5.365h6.447c.087-.268.087-.626.087-.894C46.25 9.967 44.333 8 41.894 8z",
    fill: "url(#Mir__color_svg__paint0_linear_23_1391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.49 13.813v6.706h3.92v-3.577h3.484c1.917 0 3.572-1.341 4.094-3.13H34.49zM20.552 8v12.518h3.485s.87 0 1.306-.894l3.05-6.259h.435v7.153h3.92V8h-3.485s-.87.09-1.306.894l-3.05 6.26h-.435V8h-3.92zM4 20.518V8h3.92s1.133 0 1.742 1.788c1.568 4.74 1.743 5.365 1.743 5.365s.348-1.162 1.742-5.365C13.757 8 14.889 8 14.889 8h3.92v12.518h-3.92v-6.706h-.435l-2.178 6.707h-1.742l-2.178-6.707H7.92v6.707H4z",
    fill: "#357251"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Mir__color_svg__paint0_linear_23_1391",
    x1: 34.044,
    y1: 8,
    x2: 46.563,
    y2: 14.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5FD0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Mir__color_svg__clip0_23_1391"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 8)",
    d: "M0 0h42.25v12.518H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirColor);
export default __webpack_public_path__ + "static/media/Mir__color.bc06a0e3b8d6050715be8ae8ee4f605d.svg";
export { ForwardRef as ReactComponent };